export default __webpack_public_path__ + "static/media/back-cover-sucursal.341887da.jpg";